import { rgba } from 'polished';
export var getAlertStyles = function getAlertStyles(_ref) {
  var theme = _ref.theme,
      palette = _ref.palette;

  switch (palette) {
    case 'success':
      return {
        backgroundColor: theme.colors.green['100'],
        iconColor: theme.colors.green['600'],
        textColor: theme.colors.grey['900'],
        boxShadow: "0px 0px 4px ".concat(rgba(theme.colors.grey[900], 0.16))
      };

    case 'warning':
      return {
        backgroundColor: theme.colors.yellow['100'],
        iconColor: theme.colors.yellow['600'],
        textColor: theme.colors.grey['900'],
        boxShadow: "0px 0px 4px ".concat(rgba(theme.colors.grey[900], 0.16))
      };

    case 'danger':
      return {
        backgroundColor: theme.colors.red['100'],
        iconColor: theme.colors.red['600'],
        textColor: theme.colors.grey['900'],
        boxShadow: "0px 0px 4px ".concat(rgba(theme.colors.grey[900], 0.16))
      };

    case 'neutral':
      return {
        backgroundColor: theme.colors.grey['100'],
        iconColor: theme.colors.grey['600'],
        textColor: theme.colors.grey['900'],
        boxShadow: "0px 0px 4px ".concat(rgba(theme.colors.grey[900], 0.16))
      };

    case 'primary':
      return {
        backgroundColor: theme.colors.blue['100'],
        iconColor: theme.colors.blue['600'],
        textColor: theme.colors.grey['900'],
        boxShadow: "0px 0px 4px ".concat(rgba(theme.colors.grey[900], 0.16))
      };

    default:
      throw new Error('Invalid palette');
  }
};